import React from "react";
import { Box, Typography } from "@mui/material";
import Paycash from "../../../../../../../assets/Images/cash-on-delivery.png";
import buyoncredit from "../../../../../../../assets/Images/cash.png";
import { useBusinessTheme } from "src/shared/utils/useBusinessTheme";
import { ModalWrapper } from "src/shared/components/ModalWrapper";

interface PaymentMethodDialogProps {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  onPaymentMethodSelect: (method: string) => void;
}

const PaymentMethodDialog: React.FC<PaymentMethodDialogProps> = ({ open, onClose, onBack, onPaymentMethodSelect }) => {
  const { loading } = useBusinessTheme();

  if (loading || !open) return null; // hide modal when not open or still loading

  return (
    <ModalWrapper title="Payment Confirmation" onClose={onClose} onBack={onBack} showBackButton showCloseButton width="max-w-lg">
      {/* Subtitle */}
      <Typography variant="subtitle1" textAlign="center" sx={{ mb: 2, fontSize: "1rem", fontWeight: 500 }}>
        Choose the payment option that fits your needs
      </Typography>

      <Box className="payment-design">
        {/* Buy on Credit */}
        <Box
          className="payment-option-saloon"
          onClick={() => onPaymentMethodSelect("Buy on credit")}
          sx={{
            cursor: "pointer",
            "& span": { fontFamily: "var(--fontfamily)" },
          }}
        >
          <img src={buyoncredit} alt="Buy on credit" />
          <span>Buy on credit</span>
        </Box>

        {/* Cash */}
        <Box
          className="payment-option-saloon"
          onClick={() => onPaymentMethodSelect("cash")}
          sx={{
            cursor: "pointer",
            "& span": { fontFamily: "var(--fontfamily)" },
          }}
        >
          <img src={Paycash} alt="Cash" />
          <span>Cash</span>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default PaymentMethodDialog;
